import React, {Component} from 'react';
import Avatar from 'react-avatar-edit'
//import AvatarEditor from 'react-avatar-editor'
import AvatarDisplay from "./avatarDisplay"

class AvatarEditor extends Component {
    constructor(props) {
        super(props);
        const avatar = `${process.env.PUBLIC_URL}/assets/images/team/avatars/avatar.jpg`

        this.state = {
            preview: this.props.userAvatar ? this.props.userAvatar : avatar
        }
        this.onCrop = this.onCrop.bind(this)
        this.onBeforeFileLoad = this.onBeforeFileLoad.bind(this)
        
    }

    onCrop(preview) {
        this.setState({preview})
        if (this.props.onCrop) {this.props.onCrop(preview)}
    }

    onBeforeFileLoad(elem) {
        if(elem.target.files[0].size > 1000000){
            alert("File is too big!");
            elem.target.value = "";
        };
    }

    render () {
        return (
            <div className="container">
                <div className="row ">
                    <div className="col-12">
                        <Avatar
                            width={350}
                            height={350}
                            onCrop={this.onCrop}
                            onBeforeFileLoad={this.onBeforeFileLoad}
                        />
                    </div>
                </div>
                <div className="row " style={{marginTop: "32px"}}>
                    <div className="col-sm-8 offset-sm-2">
                        <AvatarDisplay size={200} src={this.state.preview} />                                                                                                                                     
                    </div>
                </div>
            </div>

        )
    }
    
}

export default AvatarEditor;